import {CircleAlert, Clock} from 'lucide-react';
import type {StatusTone} from '@/modules/provider-console/components/statusTone';

export const demoNotifications = [
    {
        id: 1,
        title: 'Kelly Paulson Results require clinical review',
        detail: 'Biotin Clinical Panel',
        cta: 'Review',
        tone: 'danger' as StatusTone,
        icon: CircleAlert,
    },
    {
        id: 2,
        title: 'Upcoming Telehealth Appointment',
        detail: 'Dr. Reeves · October 18 · 1:30 pm',
        cta: 'Details',
        tone: 'info' as StatusTone,
        icon: Clock,
    },
    {
        id: 3,
        title: 'Replace Wellness Kits',
        detail: '3 kits remaining in inventory',
        cta: 'Review',
        tone: 'warning' as StatusTone,
        icon: Clock,
    },
    {
        id: 4,
        title: 'Jessica Collins Results ready',
        detail: 'Advanced Thyroid Panel',
        cta: 'Review',
        tone: 'success' as StatusTone,
        icon: CircleAlert,
    },
    {
        id: 5,
        title: 'Upcoming Telehealth Appointment',
        detail: 'Dr. Reeves · October 21 · 11:00 am',
        cta: 'Details',
        tone: 'default' as StatusTone,
        icon: Clock,
    },
];
